<template>
    <li @click.prevent="openDropdown()" class="has-dropdown language-selector">
        <a href="#"><img :src="activeImage"> {{ activeText }}</a>
        <ul :class="{'active': hasDropdown}" class="dropdown-menu">
            <router-link v-for="lang in langs" :key="lang.locale" v-if="! lang.active && name" :to="routeParams(lang.locale)" tag="li">
                <a><img :src="'/assets/img/'+lang.locale+'.png'"> {{ lang.text }}</a>
            </router-link>
        </ul>
    </li>
</template>
<script>
    export default {
        data() {
            return {
                name: false,
                prevLang: false,
                transKeys: {
                    'vini-bianchi': 'routes.wines.white',
                    'white-wines': 'routes.wines.white',
                    'vini-rossi': 'routes.wines.red',
                    'red-wines': 'routes.wines.red',
                    'vini-frizzanti': 'routes.wines.sparkling',
                    'sparkling-wines': 'routes.wines.sparkling',
                },
                langs: {
                    en: {
                        locale: 'en',
                        text: 'EN',
                        active: false
                    },
                    it: {
                        locale: 'it',
                        text: 'IT',
                        active: false
                    },
                    ja: {
                        locale: 'ja',
                        text: '日本語',
                        active: false
                    }
                },
                hasDropdown: false
            }
        },
        mounted() {
            this.setActive();
        },
        methods: {
            setActive() {
                if( ! this.$route.name ) return;

                this.name = this.$route.name.replace(this.$i18n.locale+'.', '');
                if( this.prevLang ) {
                    this.langs[this.prevLang].active = false
                }
                this.langs[this.$i18n.locale].active = true
                this.prevLang = this.$i18n.locale
            },
            routeParams( locale ) {
                if( locale === 'ja' ) return { name: 'it.contact' };

                let params = { name: locale+'.'+this.name };

                if( this.name === 'keykeg' && locale === 'en' ) {
                    params = { name: locale+'.package' }
                }

                if( this.$route.name.includes('.collection.') ) {
                    params.params = { wine: this.$t( this.transKeys[this.$route.params.wine], locale ) }
                }

                return params;
            },
            openDropdown() {
                if( window.matchMedia('(max-width: 1100px)').matches ) {
                    this.hasDropdown = !this.hasDropdown;
                }
            }
        },
        computed: {
            activeImage() {
                return `/assets/img/${this.$i18n.locale}.png`
            },
            activeText() {
                return this.langs[this.$i18n.locale].text
            }
        },
        watch: {
            '$route' (to, from) {
                this.setActive()
            },
        }
    }
</script>